<template>
<div v-if="showTrans">
    <div  class="transission" :style="'left:calc(50% - '+(transOuter+transInner/2)+'px);top:calc(50% - '+(transOuter+transInner/2)+'px);width:'+transInner+'px;height:'+transInner+'px;border:#000 solid '+transOuter+'px;'"></div>
    <div class="transText" :style="'opacity:'+textOpacity+';'">{{transText}}</div>
</div>
</template>

<script>
import gsap from "gsap";
import screen from "@/mixins/screen"

export default {
  mixins:[ screen],
  components: {
   
  },
  data() {
    return {
       transInner:1000,
       transOuter:1000,
       showTrans:false,
       textOpacity:0,
    };
  },
  mounted(){
    this.transInner=this.transInnerMax
    this.transOuter=this.transInnerMax
    //gsap.delayedCall(10,this.transOut)
  },
  computed:{
    transInnerMax(){
      return Math.max(this.windowWidth,this.windowHeight)*2
    },
    transText(){
      if(this.transition)
      {
        return this.transition.text
      }
    },
    transState(){
      if(this.transition)
      {
      return this.transition.state
      }
    },
    transition(){
      return this.$store.getters.getTransition
    }
  },
  methods:{

    transIn(){
      this.showTrans=true
      gsap.to(this,1.5,{transInner:0})
      gsap.to(this,.3,{textOpacity:1,delay:1.6,onComplete:this.transHold})
    },
    transHold(){
      if(this.transition.to){
        this.$router.push({ path: this.transition.to })
      }
      gsap.delayedCall(1.5,this.transOut)
     
    },
    transOut(){
      gsap.to(this,.3,{textOpacity:0})
      gsap.to(this,1.5,{transInner:this.transInnerMax,delay:.6,onComplete:this.transDone})
      
    },
    transDone(){
       this.showTrans=false
       this.$store.commit('setTransition',null)
    }
  },
  watch:{
    transState(val){
      
      if(val=="transIn"){
        this.transIn()
      }
    }
  }
};
</script>

<style>
  .transission{
    z-index: 3;
    position:absolute;
    left:calc(50% - 1050px);
    top:calc(50% - 1050px);
    width:100px;
    height:100px;
    border-radius:50%;
    border:#000 solid 1000px;
  }
  .transText{
    z-index: 4;
    font-size:60px;
    width:100%;
    position:absolute;
    bottom:50%;
    color:#fff;
  }
</style>